import { Backdrop, CircularProgress } from "@mui/material";

const FullPageLoader = () => {
  return (
    <Backdrop
      open
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CircularProgress color="inherit" />
      </div>
    </Backdrop>
  );
};

export default FullPageLoader;
